import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutStopQuickInfo extends Layout {
    labelId: Label;
    sourceStop: DataSource;
    table1: Table;
}
